module.exports = __webpack_public_path__ + "img/backpack_thumb.5d64be4c.jpg";